import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { useEffect } from "react";
import { CartProvider } from "./components/CartProvider";
import { router } from "./lib/router";
import { useShopSettings } from "@/hooks/useShopSettings";

function injectHeadLink(rel: string, href: string, attrs?: Record<string, string>) {
  const link = document.createElement("link");
  link.rel = rel;
  link.href = href;
  if (attrs) for (const [k, v] of Object.entries(attrs)) link.setAttribute(k, v);
  document.head.appendChild(link);
}

injectHeadLink("icon", "/favicon.svg", { type: "image/svg+xml" });
injectHeadLink("manifest", "/site.webmanifest");

function DocumentTitleFixer() {
  const { data } = useShopSettings();
  useEffect(() => {
    if (data?.home_title && document.title.includes("{{")) {
      document.title = data.home_title;
    }
  }, [data?.home_title]);
  return null;
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
});

const app = (
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <DocumentTitleFixer />
      <CartProvider>
        <RouterProvider router={router} />
      </CartProvider>
    </QueryClientProvider>
  </StrictMode>
);

const elem = document.getElementById("root")!;

if (import.meta.hot) {
  // With hot module reloading, `import.meta.hot.data` is persisted.
  const root = (import.meta.hot.data.root ??= createRoot(elem));
  root.render(app);
} else {
  // The hot module reloading API is not available in production.
  createRoot(elem).render(app);
}
